import React from 'react';

// Reusable styled inputs
export const Field = ({ label, value, onChange, textarea, rows = 3, placeholder = '', type = 'text', className = '' }) => (
  <div className={className}>
    {label && <label className="block text-[11px] tracking-[0.15em] uppercase text-white/50 mb-1.5">{label}</label>}
    {textarea ? (
      <textarea
        rows={rows}
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="w-full rounded-md bg-[#0a1f1a] border border-white/10 focus:border-[#e0b972] focus:outline-none px-3 py-2 text-[13.5px] text-white placeholder:text-white/25 transition-colors resize-y"
      />
    ) : (
      <input
        type={type}
        value={value || ''}
        onChange={(e) => onChange(type === 'number' ? Number(e.target.value) : e.target.value)}
        placeholder={placeholder}
        className="w-full rounded-md bg-[#0a1f1a] border border-white/10 focus:border-[#e0b972] focus:outline-none px-3 py-2 text-[13.5px] text-white placeholder:text-white/25 transition-colors"
      />
    )}
  </div>
);

export const Section = ({ title, description, children }) => (
  <section className="rounded-lg border border-white/10 bg-white/[0.02] p-6">
    <div className="flex items-baseline justify-between gap-4">
      <h3 className="font-serif text-xl text-white">{title}</h3>
    </div>
    {description && <p className="mt-1 text-[12.5px] text-white/50">{description}</p>}
    <div className="mt-5 space-y-4">{children}</div>
  </section>
);

export const StringList = ({ label, value = [], onChange }) => {
  const update = (i, v) => {
    const next = [...value];
    next[i] = v;
    onChange(next);
  };
  const add = () => onChange([...value, '']);
  const remove = (i) => onChange(value.filter((_, idx) => idx !== i));

  return (
    <div>
      {label && <label className="block text-[11px] tracking-[0.15em] uppercase text-white/50 mb-1.5">{label}</label>}
      <div className="space-y-2">
        {value.map((v, i) => (
          <div key={i} className="flex gap-2">
            <input
              value={v}
              onChange={(e) => update(i, e.target.value)}
              className="flex-1 rounded-md bg-[#0a1f1a] border border-white/10 focus:border-[#e0b972] focus:outline-none px-3 py-2 text-[13.5px] text-white"
            />
            <button type="button" onClick={() => remove(i)} className="px-2.5 rounded-md border border-white/10 text-white/50 hover:text-[#f27a5b] hover:border-[#f27a5b]/50 text-[12px]">−</button>
          </div>
        ))}
      </div>
      <button type="button" onClick={add} className="mt-2 text-[12px] text-[#e0b972] hover:underline">+ Ajouter</button>
    </div>
  );
};
